<template>
  <head>
    <!-- fonts -->
    <link rel="stylesheet" href="/assets/vendors/icon_fonts/css/all_icons.min.css">
    <link rel="stylesheet" href="/assets/vendors/icon_fonts/css/elegant-icons.css">
    <link rel="stylesheet" href="/assets/vendors/icon_fonts/css/fontello-codes.css">
    <link rel="stylesheet" href="/assets/vendors/icon_fonts/css/simple-line-icons.css">
    <link rel="stylesheet" href="/assets/vendors/icon_fonts/css/icon_set_1.css">
    <link rel="stylesheet" href="/assets/vendors/icon_fonts/css/icon_set_2.css">
    <link rel="stylesheet" href="/assets/vendors/icon_fonts/css/icon_set_3.css">
    <link rel="stylesheet" href="/assets/vendors/icon_fonts/css/icon_set_4.css">

    <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/bootstrap-select/1.13.18/css/bootstrap-select.min.css">

    <link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/@mdi/font@5.9.55/css/materialdesignicons.min.css">
    <link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/bootstrap-select@1.13.14/dist/css/bootstrap-select.min.css">

    <!-- css -->
    <link rel="stylesheet" href="/assets/css/bootstrap.min.css">
    <link rel="stylesheet" href="https://stackpath.bootstrapcdn.com/bootstrap/4.3.1/css/bootstrap.min.css">
    <link rel="stylesheet" href="/assets/css/fontawesome-all.min.css">
    <link rel="stylesheet" href="/assets/css/animate.min.css">
    <link rel="stylesheet" href="/assets/css/slicknav.min.css">
    <link rel="stylesheet" href="/assets/css/owl.carousel.min.css">
    <link rel="stylesheet" href="/assets/css/magnific-popup.css">
    <link rel="stylesheet" href="/assets/css/style.css">


  </head>

  <!-- Language Selector -->
  <div class="language-selector">
    <i class="mdi mdi-translate"></i>
    <select v-model="currentLanguage" @change="changeLanguage" class="form-control-sm">
      <option value="en">English</option>
      <option value="sw">Kiswahili</option>
      <option value="kam">Kikamba</option>
    </select>
  </div>

  <!-- message place holder -->
  <div class="d-sm-none d-xs-none d-md-flex d-none">
    <div class="d-flex flex-grow-1">
      <div class="px-3 p-2 bg-warning">
        <p class="mb-0 pb-0 text-black text-uppercase">{{ t('newsUpdates') }}</p>
      </div>
      <div class="bg-black flex-grow-1 text-white p-2 px-3">
        <marquee behavior="" direction="" class="d-flex">
          {{county.message}}
        </marquee>
      </div>
    </div>
  </div>

  <div class="landing-page-container position-relative w-100">
    <!--Header -->
    <header class="">
      <div class="container-fluid">
        <div class="row align-items-center">
          <div class="col-xl-4 col-md-4">
            <div class="logo-container">
              <img :src="county_logo" class="logo">
              <div>
                <h4 class="text-secondary font-apple text-nowrap mb-0">{{ t('selfServicePortal') }} <span class="text-primary d-none">Government</span></h4>
                <small class="text-secondary">{{ t('countyGovernmentOf') }} {{county.countyName}}</small>
              </div>
            </div>
            <a href="index-2.html" class="logo d-none"><img :src="county_logo" alt=""></a>
          </div>
          <div class="col-xl-6 d-none d-xl-block">
            <nav>
              <ul>
              </ul>
            </nav>
          </div>
          <div class="col-xl-2 col-md-8 d-flex justify-content-end">
            <div class="offcanvas">
              <a href="#" class="offcanvas-times"><i class="far fa-times"></i></a>
              <a href="index-2.html" class="offcanvas-logo"><img src="/img/offcanvas-logo.png" alt=""></a>
              <p>Minimal & Creative Portfolio/CV/Biodata Solution in One Platform.</p>
              <div class="social-icons">
                <a href="#"><i class="fab fa-facebook-f"></i></a>
                <a href="#"><i class="fab fa-twitter"></i></a>
                <a href="#"><i class="fab fa-behance"></i></a>
                <a href="#"><i class="fab fa-linkedin"></i></a>
                <a href="#"><i class="fab fa-youtube"></i></a>
              </div>
              <div class="single-offcanvas-contact">
                <span>{{ t('sentMail') }}</span>
                <a href="mailto:">me@example.com</a>
                <a href="mailto:">someone@example.com</a>
              </div>
              <div class="single-offcanvas-contact">
                <span>{{ t('makeCall') }}</span>
                <a href="tel:+">+786 75723 58362</a>
                <a href="tel:+">+786 75723 68271</a>
              </div>
              <div class="single-offcanvas-contact">
                <span>{{ t('getInTouch') }}</span>
                <a href="#">16/A, Hamburger City New York, US</a>
              </div>
            </div>
            <div class="offcanvas-overlay"></div>
          </div>
          <div class="col-lg-12 d-xl-none">
            <div class="mobile-menu"></div>
          </div>
        </div>
      </div>
    </header>
    <!--Header -->
    <main :style="{ backgroundImage: `url(${backgroundImage})` }" class="home-bg-img">
      <!-- slider -->
      <section class=" slider-carousel" id="home">
        <div class="single-slider">
          <div class="container">
            <div class="slider-thumb">
              <img :src="selfServiceOverlay" alt="" />
            </div>
            <div class="row">
              <div class="col-xl-7 col-lg-9">
                <div class="slider-text">
                  <span class="wow animated fadeInDown">{{ t('countyGovernmentOf') }} {{county.countyName}}</span>
                  <h2>
                    {{ t('selfService') }} <strong class="text-primary">{{ t('portal') }}.</strong>
                  </h2>
                  <p>{{ t('accessCountyRevenue') }}</p>

                  <div class="slider-btn">
                    <a href="#about" class="btn d-none">{{ t('createAccount') }}</a>
                    <a class="popup-video all-service-option">
                      <i class="mdi mdi-widgets-outline"></i> {{ t('countyServices') }}</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <!-- selecting services -->
      <section class="publibg-primary bg-primary">
        <div class="revenue-services container bg-primary">
          <div class="row">
            <div class="col-xl-3 d-xs-none d-none col-md-4 d-sm-none d-md-block">
              <div class="services-text">
                <h4>{{county.countyName}} {{ t('county') }}</h4>
                <p>{{county.tagline2}}</p>
              </div>
            </div>

            <!-- the services -->
            <div class="col-xl-9 col-md-8 the-services-container">
              <div class="h-100 d-flex">
                <div class="row w-100">
                  <div class="col-4">
                    <!-- revenue main service 1 -->
                    <div class="parking-service-option">
                      <div class="the-service">
                        <img src="/img/icons/landingpage-services/parking.svg" />
                        <div>
                          <h4>{{ t('parking') }}</h4>
                          <p>{{ t('payNow') }} <i class="mdi mdi-arrow-right"></i></p>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- revenue main service 2 -->
                  <div class="col-4">
                    <div class="trade-service-option">
                      <div class="the-service">
                        <img src="/img/icons/landingpage-services/trade.svg" />
                        <div>
                          <h4>{{ t('trade') }}</h4>
                          <p>{{ t('payNow') }} <i class="mdi mdi-arrow-right"></i></p>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="col-4">
                    <!-- revenue main service 3 -->
                    <div class="bill-service-option">
                      <div class="the-service border-right-0">
                        <img src="/img/icons/landingpage-services/bill.svg" />
                        <div>
                          <h4>{{ t('bills') }}</h4>
                          <p>{{ t('payNow') }} <i class="mdi mdi-arrow-right"></i></p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>
  </div>

  <!-- services aside container -->
  <div class="aside-container">
    <aside class="right-neg-100" id="all-service-option">
      <div class="aside-header">
        <div class="header-side">
          <h4>{{ t('allServices') }}</h4>
          <i class="mdi mdi-close close-aside"></i>
        </div>
        <p>{{ t('selectServiceBelow') }}</p>
      </div>

      <!-- the sub menu streams -->
      <ul class="sub-streams-services">
        <li class="parking-service-option">
          <div class="the-border-menu"></div>
          <div>
            <img src="/img/icons/landingpage-services/black-parking.svg" class="img" />
          </div>
          <div>
            <strong>{{ t('parking') }}</strong>
          </div>
        </li>

        <li class="trade-service-option">
          <div class="the-border-menu"></div>
          <div>
            <img src="/img/icons/landingpage-services/black-trade.svg" class="img" />
          </div>
          <div>
            <strong>{{ t('tradeLicense') }}</strong>
          </div>
        </li>

        <li class="bill-service-option">
          <div class="the-border-menu"></div>
          <div>
            <img src="/img/icons/landingpage-services/black-bill.svg" class="img" />
          </div>
          <div>
            <strong>{{ t('countyBills') }}</strong>
          </div>
        </li>
      </ul>
    </aside>

    <aside class="right-neg-100" id="parking-service-option">
      <div class="aside-header">
        <div class="header-side">
          <h4>{{ t('parking') }}</h4>
          <i class="mdi mdi-close close-aside"></i>
        </div>
        <p>{{ t('selectOptionFromList') }}</p>
      </div>

      <ul class="sub-streams">
        <li
            v-for="(item, index) in incomeTypes"
            :key="index"
            @click="setModalMessage(item.incomeTypeDescription, item.incomeTypePrefix,item.incomeTypeId) "
            class="parking"
        >
          <div>
            <img :src="getIconPath(item.incomeTypeDescription)" class="img"/>
          </div>
          <div>
            <strong>{{ item.incomeTypeDescription }}</strong>
            <p>{{ t('parkingFeeDescription') }}</p>
          </div>
        </li>
      </ul>
    </aside>

    <aside class="right-neg-100" id="bill-service-option">
      <div class="aside-header">
        <div class="header-side">
          <h4>{{ t('bills') }}</h4>
          <i class="mdi mdi-close close-aside"></i>
        </div>
        <p>{{ t('selectOptionFromList') }}</p>
      </div>

      <!-- the sub menu streams -->
      <ul class="sub-streams">
        <!-- the inputs -->
        <div class="the-aside-inputs">
          <div class="form-group">
            <label>{{ t('billNumber') }}</label>
            <input v-on:keyup.enter="getBill" v-model="billNo" type="text" :placeholder="t('enterBillNumber')" class="form-control w-100" />
          </div>

          <div class="bill-confirm" ref="">
            <button @click="getBill" class="btn-process btn-block btn-bill-confirm">
              {{ t('getBillDetails') }}
            </button>
          </div>

          <div class="bg-error d-none">
            <p class="mb-0">{{ t('billNotFound') }}</p>
          </div>
        </div>
      </ul>
    </aside>

    <aside class="right-neg-100" id="trade-service-option">
      <div class="aside-header">
        <div class="header-side">
          <h4>{{ t('trade') }}</h4>
          <i class="mdi mdi-close close-aside"></i>
        </div>
        <p>{{ t('selectOptionFromList') }}</p>
      </div>

      <!-- the sub menu streams -->
      <ul class="sub-streams">
        <li class="register_business" data-toggle="modal" data-target="#trade-license-application">
          <div>
            <img src="/img/icons/Trade-Licenses/Trade-License.svg" class="img" />
          </div>
          <div>
            <strong>{{ t('registerNewBusiness') }}</strong>
            <p>{{ t('registerBusinessHere') }}</p>
          </div>
        </li>

        <li class="print_permit">
          <div>
            <img src="/img/icons/new-icons/line/print.svg" class="img" />
          </div>
          <div>
            <strong>{{ t('printPermit') }}</strong>
            <p>{{ t('printBusinessPermit') }}</p>
          </div>
        </li>
      </ul>
    </aside>
  </div>

  <!-- parking services sub revenue streams -->
  <div class="aside-container sub-streams parking-subs">
    <aside class="right-neg-100" id="parking">
      <div class="aside-header">
        <div class="header-side-sub">
          <div data-icon="#" aria-hidden="true" class="mdi mdi-arrow-left close-sub-aside"></div>
          <h4>{{modalMessage}}</h4>
        </div>
      </div>
      <hr />
      <!-- the inputs -->
      <div class="the-aside-inputs">
        <div class="form-group">
          <label>{{ t('parkingZone') }}<strong class="text-danger">*</strong></label>
          <select class="form-control" :title="t('selectService')" data-live-search="true" v-model="zone">
            <option v-for="(item, index) in zones" :value="item.zone" :key="index">
              {{ item.zone }}
            </option>
          </select>
        </div>

        <div class="form-group">
          <label>{{ t('vehicleType') }}<strong class="text-danger">*</strong></label>
          <select class="form-control" :title="t('selectService')" data-live-search="true" v-model="feesAndCharge">
            <option v-for="(item, index) in feesAndCharges" :value="item" :key="index">
              {{ item.feeDescription }}
            </option>
          </select>
        </div>

        <div class="form-group">
          <label>{{ t('numberPlate') }}</label>
          <input v-on:keyup.enter="addCar" type="text" :placeholder="t('enterNumberPlate')" class="form-control w-100" v-model="numberPlate" />
        </div>
      </div>

      <div class="bg-red-light computed-charges">
        <img src="/img/icons/parking/dollar.svg" />
        <div class="">
          <p>{{ t('parkingCharges') }}</p>
          <h5>{{feesAndCharge.currency}} {{ feesAndCharge.unitFeeAmount }}</h5>
        </div>
      </div>

      <div class="aside-footer-to-confirm right-neg-100">
        <div v-if="rate != null && numberPlate.length > 6" class="parking-confirm">
          <button @click="addCar()" class="btn-process btn-confirm-daily-details">
            {{ t('continueToConfirmation') }}<i class="mdi mdi-arrow-right ml-2"></i>
          </button>
        </div>
      </div>
    </aside>
  </div>

  <!-- bill services sub revenue streams -->
  <div class="aside-container aside-summary bill-subs">
    <aside class="right-neg-100" id="bill-confirm" ref="bill_summary">
      <div class="aside-header">
        <div class="header-side-sub">
          <h4>{{ t('billInformation') }}</h4>
          <span class="close-confirm-aside">{{ t('edit') }}</span>
        </div>
      </div>
      <hr />
      <!-- the inputs -->
      <div class="the-aside-inputs">
        <div class="transactions-details-container bg-confirm">
          <h5 class="">{{ billDetails.incomeTypeDescription }}</h5>
          <h6 class="mb-3">{{ t('billNo') }}: {{ billDetails.billNo }}</h6>
          <p class="">{{ t('transactionDetailsMessage') }}</p>

          <h6 class="mb-3">{{ t('customer') }}: {{ billDetails.customerName }}</h6>

          <div class="mt-3">
            <hr class="dashed" />
            <div v-for="(item, index) in billInfo" :key="item.id || index" class="d-flex justify-content-between">
              <span class="m-0">{{ item.feeDescription }}</span>
              <strong>KES {{ item.billTotal }}</strong>
            </div>

            <hr />
            <div class="d-flex justify-content-between">
              <strong class="bill-total">{{ t('total') }}</strong>
              <strong>{{billDetails.currency}} {{ billDetails.detailAmount }}</strong>
            </div>
            <div class="d-flex justify-content-between">
              <strong class="bill-total">{{ t('paid') }}</strong>
              <strong>{{billDetails.currency}} {{ billDetails.receiptAmount }}</strong>
            </div>
            <div class="d-flex justify-content-between">
              <strong class="bill-total">{{ t('balance') }}</strong>
              <strong>{{billDetails.currency}} {{ billDetails.billBalance }}</strong>
            </div>
          </div>
        </div>

        <div class="row bill-buttons mt-2">
          <div class="col-6">
            <button class="btn-process btn-success btn-pay-now w-100">
              {{ t('payNow') }}
            </button>
          </div>

          <div class="col-6">
            <button @click="printBill()" class="btn-process btn-success btn-pay-now w-100">
              {{ t('print') }}
            </button>
          </div>
        </div>
      </div>
      <div class="aside-footer-confirm right-neg-100 d-none">
        <div class="form-group mt-2">
          <label>{{ t('mpesaNo') }}</label>
          <input type="text" :placeholder="t('enterMpesaNumber')" class="form-control w-100" v-model="phoneNumber" />
        </div>

        <div class="form-group">
          <button class="btn-process" data-toggle="modal" data-target="#payment-modal">
            {{ t('pay') }} KES {{ billDetails.billBalance }}<i class="mdi mdi-arrow-right ml-2"></i>
          </button>
        </div>
      </div>
    </aside>
  </div>

  <!-- trade services sub revenue streams -->
  <div class="aside-container aside-summary trade-subs">
    <aside class="right-neg-100" id="print_permit">
      <div class="aside-header">
        <div class="header-side-sub">
          <h4>{{ t('printBusinessPermit') }}</h4>
          <i class="mdi mdi-close close-sub-aside"></i>
        </div>
      </div>
      <hr />
      <!-- the sub menu streams -->
      <ul class="sub-streams">
        <!-- the inputs -->
        <div class="the-aside-inputs">
          <div class="form-group">
            <label>{{ t('businessNumber') }}</label>
            <input v-on:keyup.enter="printTradePermit" v-model="businessID" type="text" :placeholder="t('enterBusinessNumber')" class="form-control w-100" />
          </div>

          <a @click="printTradePermit" target="new" class="btn-process btn-block btn-print-permit">{{continiueButtom}}<span class="far fa-print mx-2"></span>
          </a>

          <div v-if="businessNotFound" class="bg-error">
            <p class="mb-0">{{ t('permitNotFound') }}</p>
          </div>
        </div>
      </ul>
    </aside>
  </div>

  <!-- confirmation services sub revenue streams -->
  <div class="aside-container aside-summary parking-subs">
    <aside class="right-neg-100" id="parking-confirm">
      <div class="aside-header">
        <div class="header-side-sub">
          <h4>{{ t('transactionSummary') }}</h4>
          <span class="close-confirm-aside">{{ t('edit') }}</span>
        </div>
      </div>
      <hr />
      <!-- the inputs -->
      <div class="the-aside-inputs">
        <div class="transactions-details-container bg-confirm">
          <h5 class="mb-3">{{ modalMessage }}</h5>
          <p class="">{{ t('transactionDetailsMessage') }}</p>
          <div class="mt-3">
            <div class="d-flex justify-content-between">
              <span class="m-0">{{ t('duration') }}</span>
              <p class="seasonal-parking">
                <di v-for="(item, index) in vehicles" :key="index">
                  <strong>{{ item.duration.duration }}</strong>,
                </di>
              </p>
            </div>

            <div class="d-flex flex-column">
              <span class="m-0">{{ t('vehicles') }}</span>
              <div class="seasonal-parking">
                <div>
                  <strong>{{ numberPlate }}</strong> ({{ feesAndCharge.feeDescription }})
                </div>
              </div>
            </div>

            <hr class="dashed" />
            <div class="d-flex justify-content-between">
              <span class="m-0">{{ t('parkingCharges') }}</span>
              <strong>{{feesAndCharge.currency}} {{ feesAndCharge.unitFeeAmount }}</strong>
            </div>
            <div class="d-flex justify-content-between">
              <span class="m-0">{{ t('amountPaid') }}</span>
              <strong>KES 0.00</strong>
            </div>

            <hr />
            <div class="d-flex justify-content-between">
              <strong class="bill-total">{{ t('total') }}</strong>
              <strong>KES {{ feesAndCharge.unitFeeAmount }}</strong>
            </div>
          </div>
        </div>

        <div class="row bill-buttons mt-2">
          <div class="col-6">
            <button @click="generateParkingBill(false)" class="btn-process btn-success btn-pay-now w-100">
              {{ t('payNow') }}
            </button>
          </div>

          <div class="col-6">
            <button @click="generateParkingBill(true)" class="btn-process btn-success btn-pay-now w-100">
              {{ t('print') }}
            </button>
          </div>
        </div>
      </div>

      <div class="aside-footer-confirm right-neg-100 d-none">
        <div class="form-group mt-2">
          <label>{{ t('mpesaNo') }}</label>
          <input type="text" :placeholder="t('enterMpesaNumber')" class="form-control w-100" v-model="phoneNumber" />
        </div>

        <div class="form-group">
          <button class="btn-process" data-toggle="modal" data-target="#payment-modal">
            {{ t('pay') }} {{feesAndCharge.currency}} {{ feesAndCharge.unitFeeAmount }}<i class="mdi mdi-arrow-right ml-2"></i>
          </button>
        </div>
      </div>
    </aside>
  </div>

  <!-- payment modal -->
  <div class="modal fade" id="payment-modal" data-backdrop="static" data-keyboard="false" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <span class="badge badge-pill badge-success text-uppercase">{{ t('makePayment') }}</span>
          <button ref="Close" type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <h4 class="modal-title text-capitalize" id="exampleModalLongTitle">
            {{ modalMessage }}
          </h4>

          <br>

          <p class="mb-3">{{ t('paymentRequestMessage', { amount: `KES ${paymentData.amount}`, phoneNumber: phoneNumber }) }}</p>

          <p>{{ t('paymentTimeMessage') }}</p>
          <p><strong>{{ t('clickPayMessage') }}</strong></p>

          <br>
          <div v-if="Push.callback_returned ==='PAID'" class="alert alert-success" role="alert">
            {{Push.message}}
          </div>

          <div v-if="Push.callback_returned ==='PENDING'" class="alert alert-primary" role="alert">
            {{Push.message}}
          </div>

          <div v-if="Push.callback_returned ==='UNPAID'" class="alert alert-danger" role="alert">
            {{Push.message}}
          </div>
        </div>
        <div class="modal-footer">
          <button @click="makePayment()" type="button" class="btn-process text-capitalize btn-modal-pay">
            <span class=" animated fade-In"><i class="mdi mdi-login mr-2"></i> {{ t('pay') }}</span>
            <!-- loader -->
            <div class="timer-loader d-none animated fade-In">
              <i class="mdi mdi-timer-outline mr-2"></i><strong>30 S</strong>
            </div>
            <!-- loader -->
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- payment received modal -->
  <div class="modal fade" id="payment-received-modal" data-backdrop="static" data-keyboard="false" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true" data-target="#payment-received-modal" ref="showPaymentReceivedModal" data-toggle="modal">
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content">
        <div class="modal-body payment-modal">
          <img src="/img/icons/received.svg" class="received-img" />
          <h4 class="modal-title text-capitalize" id="exampleModalLongTitle">
            {{ t('paymentReceived') }}
          </h4>
          <hr />

          <p>{{ t('paymentReceivedMessage', {
            currency: Push.currency,
            amount: Push.amount,
            feeDescription: feesAndCharge.feeDescription,
            ref: Push.ref,
            transactionCode: Push.transaction_code
          }) }}</p>

          <p>{{ t('thankYouMessage') }}</p>

          <div class="row bill-buttons mt-5">
            <div class="col-10">
              <a @click="printReceipt()" target="new" class="btn-process btn-success btn-pay-now w-100"><span class="ti-printer mr-2"></span> {{ t('printReceipt') }}</a>
            </div>
            <div class="col-2 pl-0">
              <button ref="closeReceived" class="btn-process-outline btn-outline-info w-100" data-dismiss="modal">
                {{ t('close') }}
              </button>
            </div>
          </div>

          <p class="mt-3">{{ t('countyGovernment') }} {{ incomeTypeDescription }}</p>
        </div>
      </div>
    </div>
  </div>

  <!-- payment not received modal -->
  <div class="modal fade" id="payment-cancelled-modal" data-backdrop="static" data-keyboard="false" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content">
        <div class="modal-body payment-modal">
          <img src="/img/icons/cancelled.svg" class="received-img" />
          <h4 class="modal-title text-capitalize" id="exampleModalLongTitle">
            {{ t('paymentNotReceived') }}
          </h4>
          <hr />

          <p>{{ t('paymentNotReceivedMessage') }}</p>

          <div class="col-12 mt-5">
            <button class="btn-process-outline-black btn-success btn-pay-now w-100">
              <span class="ti-reload mr-2"></span> {{ t('retry') }}
            </button>
          </div>

          <p class="mt-3">{{ t('countyGovernmentParking') }}</p>
        </div>
      </div>
    </div>
  </div>

  <!-- sbp modal -->
  <div class="modal fade" id="trade-license-application" data-backdrop="static" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <div class="header-side">
            <h4>{{ t('tradeLicenseRegistration') }}</h4>
            <p>{{ t('fillAndDoubleCheck') }}</p>
          </div>
          <i class="mdi mdi-close" data-dismiss="modal" ref="close_form"></i>
        </div>
        <div class="modal-body">
          <form>
            <div class="slider-container wow animated slideInLeft">
              <div class="card">
                <div class="card-header">
                  <h5>{{ t('businessInformation') }}</h5>
                  <p>{{ t('fillRequiredFields') }}</p>
                </div>
                <div class="card-body row">
                  <div class="col-sm-12 col-md-4">
                    <div class="form-group">
                      <label>{{ t('businessName') }}<strong class="text-danger">*</strong></label>
                      <input v-model="trade.businessName" type="text" class="form-control form-control-lg" :placeholder="t('enterBusinessName')" />
                    </div>
                  </div>
                  <div class="col-sm-12 col-md-4">
                    <div class="form-group">
                      <label>{{ t('certificateOfIncorporation') }}<strong class="text-danger">*</strong></label>
                      <input v-model="trade.certificateOfIncorporation" type="text" class="form-control form-control-lg" :placeholder="t('enterCertificateOfIncorporation')" />
                    </div>
                  </div>
                  <div class="col-sm-12 col-md-4">
                    <div class="form-group">
                      <label>{{ t('kraPinNumber') }}<strong class="text-danger">*</strong></label>
                      <input v-model="trade.pinNumber" type="text" class="form-control form-control-lg" :placeholder="t('enterKraPinNumber')" />
                    </div>
                  </div>
                  <div class="col-sm-12 col-md-4">
                    <div class="form-group">
                      <label>{{ t('vatNumber') }}<strong class="text-danger">*</strong></label>
                      <input v-model="trade.VATNumber" type="text" class="form-control form-control-lg" :placeholder="t('enterVatNumber')" />
                    </div>
                  </div>
                  <div class="col-sm-12 col-md-8">
                    <div class="row">
                      <div class="col-sm-12 col-md-4">
                        <div class="form-group">
                          <label>{{ t('poBox') }}<strong class="text-danger">*</strong></label>
                          <input v-model="trade.POBox" type="text" class="form-control form-control-lg" :placeholder="t('enterPoBox')" />
                        </div>
                      </div>
                      <div class="col-sm-12 col-md-4">
                        <div class="form-group">
                          <label>{{ t('postalCode') }}</label>
                          <select class="form-control" :title="t('selectService')" data-live-search="true" v-model="trade.postalCode">
                            <option v-for="(item, index) in addresses" :value="item.postalCode" :key="index">
                              {{ item.postalCode }} {{ item.locality }} ({{ item.street }})
                            </option>
                          </select>
                        </div>
                      </div>
                      <div class="col-sm-12 col-md-4">
                        <div class="form-group">
                          <label>{{ t('postalTown') }}<strong class="text-danger">*</strong></label>
                          <input v-model="trade.town" type="text" class="form-control form-control-lg" :placeholder="t('enterPostalTown')" />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-12 modal-nav"></div>
                </div>
                <div class="card-footer d-flex justify-content-between">
                  <span>{{ t('step') }} 1</span>
                  <div class="modal-footer-buttons">
                    <button type="button" class="btn-process btn-next btn-success">
                      {{ t('next') }}
                      <i class="mdi mdi-arrow-right"></i>
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div class="slider-container d-none wow animated slideInLeft">
              <div class="card">
                <div class="card-header">
                  <h5>{{ t('additionalBusinessInfo') }}</h5>
                  <p>{{ t('fillRequiredFields') }}</p>
                </div>
                <div class="card-body row">
                  <div class="col-sm-12 col-md-4">
                    <div class="form-group">
                      <label>{{ t('plotNo') }}<strong class="text-danger">*</strong></label>
                      <input v-model="trade.plotNo" type="text" class="form-control form-control-lg" :placeholder="t('enterPlotNo')" />
                    </div>
                  </div>
                  <div class="col-sm-12 col-md-4">
                    <div class="form-group">
                      <label>{{ t('physicalAddress') }}<strong class="text-danger">*</strong></label>
                      <input v-model="trade.physicalAddress" type="text" class="form-control form-control-lg" :placeholder="t('enterPhysicalAddress')" />
                    </div>
                  </div>
                  <div class="col-sm-12 col-md-4">
                    <div class="form-group">
                      <label>{{ t('telephone') }} 1<strong class="text-danger">*</strong></label>
                      <input v-model="trade.telephone1" type="text" class="form-control form-control-lg" :placeholder="t('enterTelephone1')" />
                    </div>
                  </div>
                  <div class="col-sm-12 col-md-4">
                    <div class="form-group">
                      <label>{{ t('telephone') }} 2<strong class="text-danger">*</strong></label>
                      <input v-model="trade.telephone2" type="text" class="form-control form-control-lg" :placeholder="t('enterTelephone2')" />
                    </div>
                  </div>
                  <div class="col-sm-12 col-md-8">
                    <div class="row">
                      <div class="col-sm-12 col-md-4">
                        <div class="form-group">
                          <label>{{ t('county') }}<strong class="text-danger">*</strong></label>
                          <select class="form-control" :title="t('selectService')" data-live-search="true" v-model="countyID">
                            <option v-for="(item, index) in counties" :value="item.countyID" :key="index">
                              {{ item.countyName }}
                            </option>
                          </select>
                        </div>
                      </div>
                      <div class="col-sm-12 col-md-4">
                        <div class="form-group">
                          <label>{{ t('subCounty') }}</label>
                          <select class="form-control" :title="t('selectService')" data-live-search="true" v-model="subCountyID">
                            <option v-for="(item, index) in subCounties" :value="item.subCountyID" :key="index">
                              {{ item.subCountyName }}
                            </option>
                          </select>
                        </div>
                      </div>
                      <div class="col-sm-12 col-md-4">
                        <div class="form-group">
                          <label>{{ t('ward') }}<strong class="text-danger">*</strong></label>
                          <select class="form-control" :title="t('selectService')" data-live-search="true" v-model="wardID">
                            <option v-for="(item, index) in wards" :value="item.wardID" :key="index">
                              {{ item.wardName }}
                            </option>
                          </select>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-12 modal-nav"></div>
                </div>
                <div class="card-footer d-flex justify-content-between">
                  <span>{{ t('step') }} 2</span>
                  <div class="modal-footer-buttons">
                    <button type="button" class="btn-process-outline btn-previous btn-outline-info">
                      <i class="mdi mdi-arrow-left"></i>
                      {{ t('previous') }}
                    </button>
                    <button type="button" class="btn-process btn-next btn-success">
                      {{ t('next') }}
                      <i class="mdi mdi-arrow-right"></i>
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div class="slider-container d-none wow animated slideInLeft">
              <div class="card">
                <div class="card-header">
                  <h5>{{ t('lastBusinessInfo') }}</h5>
                  <p>{{ t('fillRequiredFields') }}</p>
                </div>
                <div class="card-body row">
                  <div class="col-sm-12 col-md-4">
                    <div class="form-group">
                      <label>{{ t('businessActivity') }}<strong class="text-danger">*</strong></label>
                      <select class="form-control" :title="t('selectService')" data-live-search="true" v-model="parentBrimsCode">
                        <option v-for="(item, index) in tradeCategories" :value="item.brimsCode" :key="index">
                          {{ item.businessActivityName }}
                        </option>
                      </select>
                    </div>
                  </div>
                  <div class="col-sm-12 col-md-4">
                    <div class="form-group">
                      <label>{{ t('businessActivityDescription') }}<strong class="text-danger">*</strong></label>
                      <select class="form-control" :title="t('selectService')" data-live-search="true" v-model="brimsCode">
                        <option v-for="(item, index) in tradeSubCategories" :value="item.brimsCode" :key="index">
                          {{ item.businessActivityDescription }}
                        </option>
                      </select>
                    </div>
                  </div>

                  <div class="bg-red-light computed-charges">
                    <img src="/img/icons/parking/dollar.svg" />
                    <div class="">
                      <p>{{ t('amountPayable') }}</p>
                      <h5>KES {{ trade.sbpFee }}</h5>
                    </div>
                  </div>

                  <div class="col-12 modal-nav"></div>
                </div>
                <div class="card-footer d-flex justify-content-between">
                  <span>{{ t('step') }} 3</span>
                  <div class="modal-footer-buttons">
                    <button type="button" class="btn-process-outline btn-previous btn-outline-info">
                      <i class="mdi mdi-arrow-left"></i>
                      {{ t('previous') }}
                    </button>
                    <button @click="addBusiness(true)" type="button" class="btn-process btn-submit btn-success">
                      {{ t('submit') }}
                      <i class="mdi mdi-check-all"></i>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>

  <!-- otp has been sent for confirmation -->
  <div class="modal fade" id="trade-otp" data-backdrop="static" data-keyboard="false" tabindex="-1" role="dialog" aria-labelledby="otpModalTitle" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content">
        <div class="modal-body payment-modal">
          <img src="img/icons/security_code_locked.svg" class="received-img mt-2" height="90px">
          <h4 class="modal-title text-capitalize" id="otpModalTitle">
            {{ t('otpVerificationRequired') }}
          </h4>
          <hr>

          <p>{{ t('otpSentMessage', {
            phone: maskPhoneNumber(permit.ownerPhone),
            email: maskEmail(permit.ownerEmail),
            businessID: permit.businessID
          }) }}</p>

          <p class="mt-3">{{ t('otpInstructions') }}</p>

          <div class="form-group mt-">
            <input v-model="otpCode" type="text" class="form-control text-center mt-3" :placeholder="t('enterOtp')" maxlength="6">
          </div>

          <div v-if="alert.success" class="alert alert-success" role="alert">
            {{message}}
          </div>

          <div v-if="alert.info" class="alert alert-primary" role="alert">
            {{message}}
          </div>

          <div v-if="alert.failed" class="alert alert-danger" role="alert">
            {{message}}
          </div>

          <div @click="printTradePermit()" class="col-sm-12 col-md-7 text-center">
            <p><a href="javascript: void(0);">{{ t('resendOtp') }}</a></p>
          </div>

          <div class="row bill-buttons mt-5">
            <div class="col-10">
              <button @click="OTPVerificationPermit" class="btn-process btn-success btn-pay-now w-100" fdprocessedid="19ojy">
                <span class="ti-printer mr-2"></span> {{ t('verifyOtp') }}
              </button>
            </div>
            <div class="col-2 pl-0">
              <button class="btn-process-outline btn-outline-info w-100" data-dismiss="modal" fdprocessedid="4f1se7">
                {{ t('close') }}
              </button>
            </div>
          </div>

          <p class="mt-3">{{county.countyName}}</p>
        </div>
      </div>
    </div>
  </div>
  <!-- end of OTP -->
</template>

<script>
/* eslint-disable */
import { execute, parking, trade, biller, paysol, self_service_bg, county_logo, authUrl, self_service_overlay } from "@/api";
import router from "@/router";

// Translation system
const translations = {
  kam: {
    // Header and general
    newsUpdates: "Ndũmĩĩi Syaũ",
    selfServicePortal: "Kĩvandanĩ kya Kwĩtethya",
    countyGovernmentOf: "Gavana wa Kaũnti ya",
    selfService: "Wĩtethyo",
    portal: "Kĩvandanĩ",
    accessCountyRevenue: "Ũngĩ wĩkala kũtũmĩa mũtandao wa kũndĩa ũtũngũ wa kaũnti",
    createAccount: "Ũndĩe akaũnti",
    countyServices: "Wĩtethyo wa kaũnti",
    county: "Kaũnti",

    // Services
    parking: "Paking'i",
    trade: "Wĩyambĩĩi",
    bills: "Mbilu",
    payNow: "Ĩva ũmũnthĩ",
    allServices: "Wĩtethyo Woonthe",
    selectServiceBelow: "Sakũa ũtethyo kũma vaa ĩtheo",
    tradeLicense: "Laiseni ya Wĩyambĩĩi",
    countyBills: "Mbilu sya Kaũnti",

    // Common form labels
    selectOptionFromList: "Sakũa kĩndũ kũma listi ĩno ya vaa ĩtheo",
    selectService: "Sakũa ũtethyo",
    enterBillNumber: "Ĩkĩa namba ya mbilu",
    enterBusinessNumber: "Ĩkĩa namba ya wĩyambĩĩi",
    enterNumberPlate: "Ĩkĩa namba ya ngaĩ",
    enterMpesaNumber: "Ĩkĩa namba ya Mpesa",

    // Parking specific
    parkingZone: "Vandu va Paking'i",
    vehicleType: "Mũthemba wa ngaĩ",
    numberPlate: "Namba ya ngaĩ",
    parkingCharges: "Mbesa sya paking'i",
    parkingFeeDescription: "Mbesa ĩno nĩĩkwĩtĩkĩthya paking'i yaku mũthenya ũmwe",
    continueToConfirmation: "Thĩĩ na mbee kũthibitisha",

    // Bill specific
    billNumber: "Namba ya Mbilu",
    getBillDetails: "Ata maũndũ ma mbilu",
    billNotFound: "Mbilu ndĩonekene",
    billInformation: "MAŨNDŨ MA MBILU",
    billNo: "Mbilu Na",
    customer: "Mũnendũ",

    // Trade specific
    registerNewBusiness: "Andĩkĩthya Wĩyambĩĩi Mũseo",
    registerBusinessHere: "Andĩkĩthya wĩyambĩĩi waku vaa",
    printPermit: "Sĩndĩka Ĩthini",
    printBusinessPermit: "Sĩndĩka Ĩthini ya Wĩyambĩĩi",
    permitNotFound: "Ĩthini ndĩonekene",
    businessNumber: "Namba ya Wĩyambĩĩi",

    // Transaction
    transactionSummary: "MŨTARATARA WA MALIPO",
    transactionDetailsMessage: "Vaa ĩtheo nĩ maũndũ ma malipo ala wanengĩte na mbesa ila syataawe kwa malipo maku",
    total: "YOONTHE",
    paid: "SYAĨVĨTWE",
    balance: "Ila isalĩte",
    edit: "THŨKŨMA",
    duration: "Ĩvinda",
    vehicles: "Ngaĩ",
    amountPaid: "Mbesa Ila Yaĩvĩtwe",

    // Payment
    makePayment: "Ĩva mbesa",
    pay: "Ĩva",
    paymentReceived: "Mbesa Syambĩĩwe",
    paymentNotReceived: "Mbesa syaile kũmbĩwa",
    paymentRequestMessage: "Kũsũma kwa mbesa sya {amount} nĩkũkũtũmwa sĩmũ yanĩ yakũ ({phoneNumber}) wavĩnya ũkanya kĩtũngi kya kũĩva vaa ĩtheo. Ĩkũlya ũĩna mbesa ya kũĩgana mpesa yakũ.",
    paymentTimeMessage: "Vayĩla kũsũma kwa mbesa kwatũmwa sĩmũ yakũ, ũkaethĩwa na sekunde 30 kũsakũa malipo na kwĩkĩa namba yakũ ya siri ya Mpesa sĩmũ yakũ.",
    clickPayMessage: "Kanya Ĩva vaa ĩtheo ũngĩ mwĩtĩke kũthĩĩ na mbee.",
    paymentReceivedMessage: "{currency} {amount} ta mbesa syakũ sya {feeDescription} kwa {ref}. Namba yakũ ya ĩsiti nĩ {transactionCode}.",
    paymentNotReceivedMessage: "Mbesa syakũ syaile kũmbĩwa, no ũkaethĩwa wakĩĩa ĩvinda yaĩasa mbee wa kwĩkĩa PIN yakũ. Kanya ĩtika ĩngĩ vaa ĩtheo kana ĩva mbesa mũno kũtũmĩa mpesa na kũtũmĩa namba ya kũĩvĩa 1234 na akaũnti yakũ nĩ 76768DHJJH",
    thankYouMessage: "Nĩ twasya mũno kũtũmĩa ũtethyo witũ. Ĩkala na mũthenya mwega.",

    // Actions
    print: "Sĩndĩka",
    printReceipt: "Sĩndĩka Ĩsiti",
    close: "funga",
    retry: "Ĩtika ĩngĩ",
    mpesaNo: "Namba ya Mpesa",

    // Business registration form
    tradeLicenseRegistration: "Kwandĩkĩthya Laiseni ya Wĩyambĩĩi",
    fillAndDoubleCheck: "Ĩkĩa na ũkũmbũkanye kũsisya maũndũ makũ kĩla ĩvinda",
    businessInformation: "Maũndũ ma wĩyambĩĩi",
    additionalBusinessInfo: "Maũndũ angĩ ma wĩyambĩĩi",
    lastBusinessInfo: "Maũndũ ma mũisho ma wĩyambĩĩi",
    fillRequiredFields: "Ĩkĩa vandu voonthe vala vĩtangatĩtwe(*).",
    businessName: "Ĩsyĩtwa ya Wĩyambĩĩi",
    enterBusinessName: "Ĩkĩa Ĩsyĩtwa ya Wĩyambĩĩi",
    certificateOfIncorporation: "Setifiketi ya kwandĩkĩthya",
    enterCertificateOfIncorporation: "Ĩkĩa Setifiketi ya kwandĩkĩthya",
    kraPinNumber: "Namba ya PIN ya KRA",
    enterKraPinNumber: "Ĩkĩa Namba ya PIN ya KRA",
    vatNumber: "Namba ya VAT",
    enterVatNumber: "Ĩkĩa Namba ya VAT",
    poBox: "Sandũkũ ya Posta",
    enterPoBox: "Ĩkĩa Sandũkũ ya Posta",
    postalCode: "Kodi ya Posta",
    postalTown: "Taũni ya posta",
    enterPostalTown: "Ĩkĩa Taũni ya posta",
    plotNo: "Namba ya Ĩatu",
    enterPlotNo: "Ĩkĩa Namba ya Ĩatu",
    physicalAddress: "Vandu va kũoneka",
    enterPhysicalAddress: "Ĩkĩa Vandu va kũoneka",
    telephone: "Sĩmũ",
    enterTelephone1: "Ĩkĩa sĩmũ 1",
    enterTelephone2: "Ĩkĩa sĩmũ 2",
    subCounty: "Kaũnti Nini",
    ward: "Wadi",
    businessActivity: "Wĩa wa Wĩyambĩĩi",
    businessActivityDescription: "Maelekeyo ma Wĩa wa Wĩyambĩĩi",
    amountPayable: "Mbesa sya Kũĩva",
    step: "ĨTENGO",
    next: "Ĩla yĩ mbee",
    previous: "ĨLA YATHĨĨTE",
    submit: "Tũma",

    // OTP
    otpVerificationRequired: "Kũthibitisha OTP Nĩ Kwĩtangatĩte",
    otpSentMessage: "OTP yatũmĩtwe kwa {phone} | {email}. Ĩkĩa OTP vaa ĩtheo kũthibitisha kwimũkya kĩthini kya Wĩyambĩĩi wa kitambũlisho {businessID}.",
    otpInstructions: "Ndũyambĩĩe? Kanya Tũma ĩngĩ. Wĩkĩĩte Kitambũlisho kĩtasĩ kya Wĩyambĩĩi? Funga nĩguo ũthũkũme. Menya: Kĩla Kitambũlisho kya Wĩyambĩĩi kĩnyiitanĩte na namba ya sĩmũ.",
    enterOtp: "Ĩkĩa OTP",
    resendOtp: "Tũma ĩngĩ OTP",
    verifyOtp: "Thibitisha OTP",

    // Contact
    sentMail: "Tũma Ĩmeyili",
    makeCall: "kũna sĩmũ",
    getInTouch: "twanĩe",

    // County specific
    countyGovernment: "Gavana wa Kaũnti",
    countyGovernmentParking: "Paking'i ya Gavana wa Kaũnti"
  },
  en: {
    // Header and general
    newsUpdates: "News Updates",
    selfServicePortal: "Self Service Portal",
    countyGovernmentOf: "County Government of",
    selfService: "Self service",
    portal: "Portal",
    accessCountyRevenue: "You can now access the county revenue collection platform",
    createAccount: "Create account",
    countyServices: "County services",
    county: "County",

    // Services
    parking: "Parking",
    trade: "Trade",
    bills: "Bills",
    payNow: "Pay now",
    allServices: "All Services",
    selectServiceBelow: "Select a service from below",
    tradeLicense: "Trade License",
    countyBills: "County Bills",

    // Common form labels
    selectOptionFromList: "Select an option from the list below",
    selectService: "Select a service",
    enterBillNumber: "Enter Bill Number",
    enterBusinessNumber: "Enter Business Number",
    enterNumberPlate: "Enter Number plate",
    enterMpesaNumber: "Enter Mpesa Number",

    // Parking specific
    parkingZone: "Parking Zone",
    vehicleType: "Vehicle type",
    numberPlate: "Number plate",
    parkingCharges: "Parking Charges",
    parkingFeeDescription: "This fee will cover your parking for just a single day",
    continueToConfirmation: "Continue to confirmation",

    // Bill specific
    billNumber: "Bill Number",
    getBillDetails: "Get Bill Details",
    billNotFound: "Bill Not Found",
    billInformation: "BILL INFORMATION",
    billNo: "Bill No",
    customer: "Customer",

    // Trade specific
    registerNewBusiness: "Register New Business",
    registerBusinessHere: "Register your business here",
    printPermit: "Print Permit",
    printBusinessPermit: "Print Business Permit",
    permitNotFound: "Permit Not Found",
    businessNumber: "Business Number",

    // Transaction
    transactionSummary: "TRANSACTION SUMMARY",
    transactionDetailsMessage: "Below are the transaction details you provided plus the computed prices for your transaction",
    total: "TOTAL",
    paid: "PAID",
    balance: "Balance",
    edit: "EDIT",
    duration: "Duration",
    vehicles: "Vehicles",
    amountPaid: "Amount Paid",

    // Payment
    makePayment: "Make payment",
    pay: "Pay",
    paymentReceived: "Payment Received",
    paymentNotReceived: "Payment not received",
    paymentRequestMessage: "A payment request of {amount} will be sent to your phone number ({phoneNumber}) soon after you click the pay button below. Make sure you have enough money in your mpesa.",
    paymentTimeMessage: "Once the payment request is sent to your phone, you will have 30 seconds to complete the payment by entering your Mpesa pin on your phone.",
    clickPayMessage: "Click Pay below when ready to continue.",
    paymentReceivedMessage: "{currency} {amount} as your {feeDescription} fee for {ref}. Your receipt number is {transactionCode}.",
    paymentNotReceivedMessage: "Your payment was not received, you may have taken too long before entering your PIN. Press retry below or pay directly through mpesa by using the paybill number 1234 and the account your account name is 76768DHJJH",
    thankYouMessage: "Thank you for using our service. Have yourself a nice day.",

    // Actions
    print: "Print",
    printReceipt: "Print Receipt",
    close: "close",
    retry: "Retry",
    mpesaNo: "Mpesa No.",

    // Business registration form
    tradeLicenseRegistration: "Trade License Registration",
    fillAndDoubleCheck: "Fill in and remember to double check your details at each stage",
    businessInformation: "Business information",
    additionalBusinessInfo: "Additional business information",
    lastBusinessInfo: "Last Business information",
    fillRequiredFields: "Please fill all the required(*) fields.",
    businessName: "Business Name",
    enterBusinessName: "Enter Business Name",
    certificateOfIncorporation: "Certificate of incorporation",
    enterCertificateOfIncorporation: "Enter Certificate of incorporation",
    kraPinNumber: "KRA Pin Number",
    enterKraPinNumber: "Enter KRA Pin Number",
    vatNumber: "VAT Number",
    enterVatNumber: "Enter VAT Number",
    poBox: "P.O Box",
    enterPoBox: "Enter P.O Box",
    postalCode: "Postal Code",
    postalTown: "Postal town",
    enterPostalTown: "Enter Postal town",
    plotNo: "Plot No",
    enterPlotNo: "Enter Plot No",
    physicalAddress: "Physical Address",
    enterPhysicalAddress: "Enter Physical Address",
    telephone: "Telephone",
    enterTelephone1: "Enter telephone 1",
    enterTelephone2: "Enter telephone 2",
    subCounty: "Sub County",
    ward: "Ward",
    businessActivity: "Business Activity",
    businessActivityDescription: "Business Activity Description",
    amountPayable: "Amount Payable",
    step: "STEP",
    next: "Next",
    previous: "PREVIOUS",
    submit: "Submit",

    // OTP
    otpVerificationRequired: "OTP Verification Required",
    otpSentMessage: "An OTP has been sent to {phone} | {email}. Enter the OTP below to confirm permit download for Business ID {businessID}.",
    otpInstructions: "Didn't receive it? Press Resend. Entered the wrong Business ID? Close to edit. Note: Each Business ID is linked to a specific phone number.",
    enterOtp: "Enter OTP",
    resendOtp: "Resend OTP",
    verifyOtp: "Verify OTP",

    // Contact
    sentMail: "Sent Mail",
    makeCall: "make call",
    getInTouch: "get in touch",

    // County specific
    countyGovernment: "County Government",
    countyGovernmentParking: "County Government Parking"
  },
  sw: {
    // Header and general
    newsUpdates: "Taarifa Mpya",
    selfServicePortal: "Kituo cha Kujihudumia",
    countyGovernmentOf: "Serikali ya Kaunti ya",
    selfService: "Huduma za kujihudumia",
    portal: "Kituo",
    accessCountyRevenue: "Sasa unaweza kufikia jukwaa la ukusanyaji wa mapato ya kaunti",
    createAccount: "Fungua akaunti",
    countyServices: "Huduma za kaunti",
    county: "Kaunti",

    // Services
    parking: "Maegesho",
    trade: "Biashara",
    bills: "Bili",
    payNow: "Lipa sasa",
    allServices: "Huduma Zote",
    selectServiceBelow: "Chagua huduma kutoka hapa chini",
    tradeLicense: "Leseni ya Biashara",
    countyBills: "Bili za Kaunti",

    // Common form labels
    selectOptionFromList: "Chagua chaguo kutoka kwenye orodha hapa chini",
    selectService: "Chagua huduma",
    enterBillNumber: "Weka Nambari ya Bili",
    enterBusinessNumber: "Weka Nambari ya Biashara",
    enterNumberPlate: "Weka Nambari ya gari",
    enterMpesaNumber: "Weka Nambari ya Mpesa",

    // Parking specific
    parkingZone: "Eneo la Maegesho",
    vehicleType: "Aina ya gari",
    numberPlate: "Nambari ya gari",
    parkingCharges: "Ada ya Maegesho",
    parkingFeeDescription: "Ada hii itasaidia maegesho yako kwa siku moja tu",
    continueToConfirmation: "Endelea kwa uthibitisho",

    // Bill specific
    billNumber: "Nambari ya Bili",
    getBillDetails: "Pata Maelezo ya Bili",
    billNotFound: "Bili Haipatikani",
    billInformation: "MAELEZO YA BILI",
    billNo: "Bili Na",
    customer: "Mteja",

    // Trade specific
    registerNewBusiness: "Sajili Biashara Mpya",
    registerBusinessHere: "Sajili biashara yako hapa",
    printPermit: "Chapisha Kibali",
    printBusinessPermit: "Chapisha Kibali cha Biashara",
    permitNotFound: "Kibali Hakipatikani",
    businessNumber: "Nambari ya Biashara",

    // Transaction
    transactionSummary: "MUHTASARI WA MUAMALA",
    transactionDetailsMessage: "Hapa chini ni maelezo ya muamala uliyotoa pamoja na bei zilizokokotolewa kwa muamala wako",
    total: "JUMLA",
    paid: "IMELIPWA",
    balance: "Salio",
    edit: "HARIRI",
    duration: "Muda",
    vehicles: "Magari",
    amountPaid: "Kiasi Kilicholipwa",

    // Payment
    makePayment: "Fanya malipo",
    pay: "Lipa",
    paymentReceived: "Malipo Yamepokelewa",
    paymentNotReceived: "Malipo hayajapokelewa",
    paymentRequestMessage: "Ombi la malipo la {amount} litatumwa kwenye nambari yako ya simu ({phoneNumber}) mara tu utakapobonyeza kitufe cha lipa hapa chini. Hakikisha una pesa za kutosha kwenye mpesa yako.",
    paymentTimeMessage: "Mara tu ombi la malipo linapotumwa kwenye simu yako, utakuwa na sekunde 30 kukamilisha malipo kwa kuingiza nambari yako ya siri ya Mpesa kwenye simu yako.",
    clickPayMessage: "Bonyeza Lipa hapa chini ukiwa tayari kuendelea.",
    paymentReceivedMessage: "{currency} {amount} kama ada yako ya {feeDescription} kwa {ref}. Nambari yako ya risiti ni {transactionCode}.",
    paymentNotReceivedMessage: "Malipo yako hayakupokelewa, huenda umechukua muda mrefu kabla ya kuingiza PIN yako. Bonyeza jaribu tena hapa chini au lipa moja kwa moja kupitia mpesa kwa kutumia nambari ya malipo 1234 na jina la akaunti yako ni 76768DHJJH",
    thankYouMessage: "Asante kwa kutumia huduma yetu. Uwe na siku njema.",

    // Actions
    print: "Chapisha",
    printReceipt: "Chapisha Risiti",
    close: "funga",
    retry: "Jaribu tena",
    mpesaNo: "Nambari ya Mpesa",

    // Business registration form
    tradeLicenseRegistration: "Usajili wa Leseni ya Biashara",
    fillAndDoubleCheck: "Jaza na kumbuka kuhakiki maelezo yako katika kila hatua",
    businessInformation: "Maelezo ya biashara",
    additionalBusinessInfo: "Maelezo ya ziada ya biashara",
    lastBusinessInfo: "Maelezo ya mwisho ya biashara",
    fillRequiredFields: "Tafadhali jaza sehemu zote zinazohitajika(*).",
    businessName: "Jina la Biashara",
    enterBusinessName: "Weka Jina la Biashara",
    certificateOfIncorporation: "Cheti cha usajili",
    enterCertificateOfIncorporation: "Weka Cheti cha usajili",
    kraPinNumber: "Nambari ya PIN ya KRA",
    enterKraPinNumber: "Weka Nambari ya PIN ya KRA",
    vatNumber: "Nambari ya VAT",
    enterVatNumber: "Weka Nambari ya VAT",
    poBox: "S.L.P",
    enterPoBox: "Weka S.L.P",
    postalCode: "Msimbo wa Posta",
    postalTown: "Mji wa posta",
    enterPostalTown: "Weka Mji wa posta",
    plotNo: "Nambari ya Kiwanja",
    enterPlotNo: "Weka Nambari ya Kiwanja",
    physicalAddress: "Anwani Halisi",
    enterPhysicalAddress: "Weka Anwani Halisi",
    telephone: "Simu",
    enterTelephone1: "Weka simu 1",
    enterTelephone2: "Weka simu 2",
    subCounty: "Kaunti Ndogo",
    ward: "Wadi",
    businessActivity: "Shughuli za Biashara",
    businessActivityDescription: "Maelezo ya Shughuli za Biashara",
    amountPayable: "Kiasi cha Kulipa",
    step: "HATUA",
    next: "Ifuatayo",
    previous: "ILIYOTANGULIA",
    submit: "Wasilisha",

    // OTP
    otpVerificationRequired: "Uthibitishaji wa OTP Unahitajika",
    otpSentMessage: "OTP imetumwa kwa {phone} | {email}. Weka OTP hapa chini kuthibitisha upakuaji wa kibali cha Biashara yenye kitambulisho {businessID}.",
    otpInstructions: "Hukuipokea? Bonyeza Tuma tena. Umeweka Kitambulisho kisicho sahihi cha Biashara? Funga ili uhariri. Kumbuka: Kila Kitambulisho cha Biashara kimehusishwa na nambari maalum ya simu.",
    enterOtp: "Weka OTP",
    resendOtp: "Tuma tena OTP",
    verifyOtp: "Thibitisha OTP",

    // Contact
    sentMail: "Tuma Barua pepe",
    makeCall: "piga simu",
    getInTouch: "wasiliana nasi",

    // County specific
    countyGovernment: "Serikali ya Kaunti",
    countyGovernmentParking: "Maegesho ya Serikali ya Kaunti"
  }
};

export default {
  name: "MainView",
  data() {
    return {
      // Language settings
      currentLanguage: 'en', // Default language

      // Original data properties
      otpCode:'',
      continiueButtom:'Continue',
      backgroundImage: self_service_bg, // Dynamic URL
      selfServiceOverlay: self_service_overlay, // Dynamic URL
      county_logo: county_logo, // Dynamic URL
      county: {
        id: null,
        countyID: null,
        countyName: null,
        tagline:null,
        smsusername: null,
        smspassword:null,
        contact: null,
        center: null,
        address:null,
        email: null,
        headline: null,
        tagline2:null,
        ussd: null,
        logo:null,
        bank: null,
        powered: null,
        stateLogo: null,
        seal: null,
        signature: null,
        QRLink:null,
        ussdCode:null,
        handPhone: null
      },
      permit: {
        id: null,
        billNo: null,
        businessID: null,
        businessName: null ,
        duration: null,
        billTotal: null,
        receiptAmount: null,
        billBalance: null,
        startDate: null,
        endDate: null,
        statusID: null,
        status: null,
        printable: null,
        issuingOfficer: null,
        designation: null,
        dateOfIssue: null,
        stageStatus: null,
        comments: null,
        incomeTypeId: null,
        feeID: null,
        subCountyID: null,
        subCountyName: null,
        wardID: null,
        wardName: null,
        plotNumber: null,
        physicalAddress: null,
        buildingName: null,
        buildingOccupancy: null,
        floorNo: null,
        roomNo: null,
        premiseSize: null,
        numberOfEmployees: null,
        tonnage: null,
        businessDes: null,
        businessCategory: null,
        businessSubCategory: null,
        incomeTypeID: null,
        businessEmail:null,
        postalAddress: null,
        postalCode: null,
        businessPhone: null,
        contactPersonNames: null,
        contactPersonIDNo: null,
        businessRole: null,
        contactPersonPhone: null,
        contactPersonEmail: null,
        fullNames: null,
        ownerID: null,
        ownerPhone: null,
        ownerEmail: null,
        kraPin: null,
        createdBy: null,
        createdByIDNo: null,
        dateCreated: null,
        lat: null,
        lng: null,
        lastRenewed: null,
        permitsCount: null,
        brimsCode: null,
        printCount: null,
        permitID:null
      },
      Push: {
        id: null,
        account_to: null,
        ref: null,
        callback_returned: null,
        TransactionDesc: null,
        mobileNotification: null,
        amount: null,
        account_from: null,
        date: null,
        code: null,
        message: null,
        transaction_code: null,
        payment_mode: null,
        posted: null,
        names: null,
        email: null,
        api_key: null,
        sms: null,
        smsResponse: null,
        company: null,
        status: null,
        remarks: null,
        currency:null,
        merchant_request_id: null,
        response: {
          MerchantRequestID: null,
          CheckoutRequestID: null,
          ResponseCode: null,
          ResponseDescription: null,
          CustomerMessage: null
        }
      },
      feesAndCharges:[{
        feeId: null,
        feeDescription: null,
        unitOfMeasure: null,
        unitFeeAmount: null,
        accountNo: null,
        incomeTypeId: null,
        feeType: null,
        accountDesc: null,
        costCenterNo: null,
        zone: null,
        typeDescription: null,
        prorated: null,
        duration: null,
        brimsCode: null,
        onUssd: null,
        currency: null
      }],
      feesAndCharge:{
        feeId: null,
        feeDescription: null,
        unitOfMeasure: null,
        unitFeeAmount: null,
        accountNo: null,
        incomeTypeId: null,
        feeType: null,
        accountDesc: null,
        costCenterNo: null,
        zone: null,
        typeDescription: null,
        prorated: null,
        duration: null,
        brimsCode: null,
        onUssd: null,
        currency: null
      },
      zone:null,
      feeId:null,
      zones: [
        {
          id: null,
          subCountyID: null,
          subCountyName: null,
          zone: null,
          wardID: null,
          wardName: null,
          lat: null,
          lng: null,
          zoneCategory: null,
          zoneCategoryID: null,
          position: null
        }
      ],
      incomeTypes: [ { incomeTypeId: null, incomeTypeDescription: null,incomeTypePrefix:null}],
      businessID: null,
      businessNotFound: false,
      mounted: false,
      billNo: null,
      modalMessage: null,
      seasonal: false,
      zoneCode: null,
      category: null,
      duration: null,
      rate: 0.0,
      options: [],
      numberPlate: "",
      vehicles: [],
      phoneNumber: null,
      message: "",
      receipt: false,
      paymentData: {
        accNo: null,
        payBillNo: null,
        amount: null,
        phoneNumber: null,
        success: false,
      },
      billGenerated: {
        billNo: null,
        payBillNo: null,
        amount: null,
        success: false,
      },
      transaction: {
        transaction_code: null,
        names: null,
        amount: null,
        account_ref: null,
      },
      receiptNo: null,
      incomeTypeDescription: null,
      timer: null,

      trade: {
        businessName: null,
        certificateOfIncorporation: null,
        pinNumber: null,
        VATNumber: null,
        POBox: null,
        postalCode: null,
        plotNo: null,
        town: null,
        telephone1: null,
        telephone2: null,
        countyID: null,
        subCountyID: null,
        wardID: null,
        address: null,
        createdBy: null,
        physicalAddress: null,
        businessActivity: null,
        businessActivityDescription: null,
        brimsCode: null,
        registrationFee: null,
        sbpFee: null,
      },
      parentBrimsCode: null,
      addresses: [],
      tradeCategories: [],
      tradeSubCategories: [],
      counties: [],
      subCounties: [],
      wards: [],
      countyID: null,
      subCountyID: null,
      wardID: null,
      brimsCode: null,
      alert:{
        success: false,
        info: false,
        failed:false
      },
      billDetails: {
        id: null,
        billNo: null,
        incomeTypeID: null,
        incomeTypeDescription: null,
        costCenterNo: null,
        accountNo: null,
        feeID: null,
        detailAmount: null,
        amountPaid: null,
        billBalance: null,
        status: null,
        dateCreated: null,
        currency:null
      },
      billInfo: [],

    };
  },
  mounted() {
    // Load saved language preference
    const savedLanguage = localStorage.getItem('preferredLanguage');
    if (savedLanguage && (savedLanguage === 'en' || savedLanguage === 'sw' || savedLanguage === 'kam')) {
      this.currentLanguage = savedLanguage;
    }

    /* this.getAddresses();
     this.getTradeCategory();
     this.getCounties();*/
    this.getIncomeTypes('PKN')
    this.getZones();
    this.getCounty()

  },

  watch: {
    duration: function () {
      this.numberPlate = "";
    },
    category: function () {
      this.numberPlate = "";
      this.getRate();
    },
    parentBrimsCode: function () {
      this.setBusinessActivity();
      this.getTradeSubCategory();
    },
    brimsCode: function () {
      this.totalTrade();
    },
    subCountyID: function () {
      this.trade.subCountyID = this.subCountyID;
      this.getWards();
    },
    wardID: function () {
      this.trade.wardID = this.wardID;
    },
  },
  methods: {
    // Translation method
    t(key, params = {}) {
      let translation = translations[this.currentLanguage][key] || translations['en'][key] || key;

      // Replace parameters in translation
      Object.keys(params).forEach(param => {
        translation = translation.replace(`{${param}}`, params[param]);
      });

      return translation;
    },

    // Language change handler
    changeLanguage() {
      localStorage.setItem('preferredLanguage', this.currentLanguage);
      // Update continue button text when language changes
      if (this.continiueButtom === 'Continue' || this.continiueButtom === 'Endelea') {
        this.continiueButtom = this.t('continue') || (this.currentLanguage === 'sw' ? 'Endelea' : 'Continue');
      }
    },

    /*Trade*/
    setBusinessActivity: function () {
      let code = this.parentBrimsCode;
      let businessActivity = null;
      this.tradeCategories.forEach(function (item) {
        if (item.brimsCode === code) {
          businessActivity = item.businessActivityName;
        }
      });
      this.trade.businessActivity = businessActivity;
    },
    totalTrade: function () {
      this.trade.brimsCode = this.brimsCode;
      let code = this.brimsCode;

      let sbpFee = 0;
      let registrationFee = 0;
      let businessActivityDescription = null;

      this.tradeSubCategories.forEach(function (item) {
        if (item.brimsCode === code) {
          sbpFee = item.sbpFee;
          registrationFee = item.registrationFee;
          businessActivityDescription = item.businessActivityDescription;
        }
      });
      this.trade.sbpFee = sbpFee;
      this.trade.registrationFee = registrationFee;
      this.trade.businessActivityDescription = businessActivityDescription;
    },
    getWards() {
      const data = new FormData();
      data.append("function", "getWards");
      data.append("subCountyID", this.subCountyID);
      execute(data, trade)
          .then((res) => {
            if (res.data.success) {
              this.wards = res.data.data.wards;
            } else {
              alert(res.data.data.message);
            }
          })
          .catch((e) => {
            alert(e.message);
          });
    },
    getSubCounties() {
      const data = new FormData();
      data.append("function", "getSubCounties");
      data.append("countyID", this.countyID);
      execute(data, trade)
          .then((res) => {
            if (res.data.success) {
              this.subCounties = res.data.data.subCounties;
            } else {
              alert(res.data.data.message);
            }
          })
          .catch((e) => {
            alert(e.message);
          });
    },
    getCounties() {
      const data = new FormData();
      data.append("function", "getCounties");
      execute(data, trade)
          .then((res) => {
            if (res.data.success) {
              this.counties = res.data.data.counties;
            } else {
              alert(res.data.data.message);
            }
            this.mounted = true
          })
          .catch((e) => {
            alert(e.message);
          });
    },
    maskEmail(email) {
      if (!email) return "";
      const [username, domain] = email.split("@");
      if (!username || !domain) return email;

      const maskedUsername =
          username.length > 2
              ? username[0] + "*".repeat(username.length - 2) + username[username.length - 1]
              : username[0] + "*";

      return `${maskedUsername}@${domain}`;
    },
    maskPhoneNumber(input) {
      if (!input || typeof input !== 'string') {
        return input; // Return as is if input is null, undefined, or not a string
      }

      const digits = input.replace(/\D/g, '');

      if (digits.length > 4) {
        return input.slice(0, 2) + input.slice(2, -2).replace(/\d/g, '*') + input.slice(-2);
      }

      return input; // Return as is if not a phone number or too short
    },
    getAddresses() {
      const data = new FormData();
      data.append("function", "getAddresses");
      execute(data, trade)
          .then((res) => {
            if (res.data.success) {
              this.addresses = res.data.data.addresses;
            } else {
              alert(res.data.data.message);
            }
          })
          .catch((e) => {
            alert(e.message);
          });
    },
    getTradeCategory() {
      const data = new FormData();
      data.append("function", "getTradeCategory");
      execute(data, trade)
          .then((res) => {
            if (res.data.success) {
              this.tradeCategories = res.data.data.tradeCategories;
            } else {
              alert(res.data.data.message);
            }
          })
          .catch((e) => {
            alert(e.message);
          });
    },
    getTradeSubCategory() {
      const data = new FormData();
      data.append("function", "getTradeSubCategory");
      data.append("brimsCode", this.parentBrimsCode);
      execute(data, trade)
          .then((res) => {
            if (res.data.success) {
              this.tradeSubCategories = res.data.data.tradeSubCategories;
            } else {
              //  alert(res.data.data.message);
            }
          })
          .catch((e) => {
            alert(e.message);
          });
    },
    addBusiness(print) {
      const data = new FormData();
      data.append("function", "addBusiness");
      data.append("trade", JSON.stringify(this.trade));
      execute(data, trade)
          .then((res) => {
            if (res.data.success) {
              this.billGenerated.billNo = res.data.data.billDetails.billNo;
              this.billGenerated.amount = res.data.data.billDetails.detailAmount;
              if (print) {
                router.push({ name: 'bill', params: { data: this.billGenerated.billNo } })
              }
            } else {
              alert(res.data.message);
            }
          })
          .catch((e) => {
            alert(e.message);
          });
    },
    printBill() {
      localStorage['params'] = JSON.stringify({
        billNo: this.billDetails.billNo
      })
      const routeData = this.$router.resolve({name: 'bill'});
      window.open(routeData.href, '_blank');
    },
    getBill() {
      const data = new FormData();
      data.append("function", "getBill");
      data.append("billNo", this.billNo);

      execute(data, biller)
          .then((res) => {
            if (res.data.success) {
              this.paymentData.amount = res.data.data.billDetails.billBalance
              this.paymentData.accNo = res.data.data.billDetails.billNo
              this.billDetails = res.data.data.billDetails;
              this.billInfo = res.data.data.billInfo;
              this.modalMessage = res.data.data.billDetails.incomeTypeDescription
            } else {
              alert(res.data.data.message);
            }
          })
          .catch((e) => {
            alert(e.message);
          });
    },
    printTradePermit() {
      this.continiueButtom = this.currentLanguage === 'sw' ? "Tafadhali subiri..." :
          this.currentLanguage === 'kam' ? "Ĩkũlya vandũ vanini..." : "Please wait..."
      this.businessNotFound = false
      const data = new FormData();
      data.append("function", "printTradePermit");
      data.append("businessID", this.businessID);
      data.append("channel", "self");
      execute(data, trade)
          .then((res) => {
            this.continiueButtom = this.currentLanguage === 'sw' ? 'Endelea' :
                this.currentLanguage === 'kam' ? 'Thĩĩ na mbee' : 'Continue'
            if (res.data.success) {
              this.permit = res.data.data.permit
              $('#trade-otp').modal('show');
            } else {
              this.businessNotFound = true
            }
          })
          .catch((e) => {
            alert(e.message);
          });
    },

    /*Parking starts here*/
    setModalMessage: function (incomeTypeDescription, incomeTypePrefix,incomeTypeId) {
      (this.zoneCode = null), (this.modalMessage = incomeTypeDescription);
      this.duration = incomeTypePrefix;
      this.getFeesAndCharges(incomeTypeId)
    },
    addCar() {
      if (this.numberPlate === "") {
        alert(this.t('enterNumberPlate'));
        return;
      }
      this.vehicles.push({
        zone: this.zoneCode,
        duration: this.duration,
        category: this.category,
        numberPlate: this.numberPlate,
        rate: this.rate,
      });
    },
    getZones() {
      this.zones.splice(0)
      const data = new FormData();
      data.append("function", "getParkingZones");
      execute(data, parking)
          .then((res) => {
            if (res.data.success) {
              this.zones = res.data.data.zones;
            } else {
              alert(res.data.data.message);
            }
          })
          .catch((e) => {
            alert(e.message);
          });
    },
    getRate() {
      if (this.zoneCode == null) this.zoneCode = "CBD";
      const data = new FormData();
      data.append("function", "getRate");
      data.append("zoneCode", this.zoneCode);
      data.append("categoryCode", this.category);
      data.append("durationCode", this.duration);

      execute(data, parking)
          .then((res) => {
            if (res.data.success) {
              this.rate = res.data.data.rate;
            } else {
              this.rate = null;
              alert(res.data.message);
            }
          })
          .catch((e) => {
            alert(e.message);
          });
    },
    makePayment() {
      if (this.phoneNumber == null) {
        const message = this.currentLanguage === 'sw' ? "Tafadhali weka nambari ya simu" :
            this.currentLanguage === 'kam' ? "Ĩkĩa namba ya sĩmũ" : "Enter phone number";
        alert(message);
        this.message = this.currentLanguage === 'sw' ? "Tafadhali weka nambari ya simu" :
            this.currentLanguage === 'kam' ? "Ĩkĩa namba ya sĩmũ" : "Kindly enter phone number";
        return;
      }
      this.message = this.currentLanguage === 'sw' ? "Ombi la malipo limetumwa" :
          this.currentLanguage === 'kam' ? "Kũsũma kwa mbesa kwatũmwa" : "Payment Request sent";
      clearInterval(this.timer);
      this.paymentData.phoneNumber = this.phoneNumber

      const data = new FormData();
      data.append("function", "makePayment");
      data.append("paymentData", JSON.stringify(this.paymentData));

      execute(data, biller)
          .then((res) => {
            if (res.data.success) {
              this.message = res.data.message;
              this.paymentData = res.data.data;
              //start checking payment
              this.timer = setInterval(() => {
                this.checkPayment();
              }, 3000);
            } else {
              this.rate = null;
              alert(res.data.message);
            }
          })
          .catch((e) => {
            alert(e.message);
          });
    },
    printReceipt() {
      if (this.receiptNo == null) {
        const message = this.currentLanguage === 'sw' ? "Jaribu tena baadaye" :
            this.currentLanguage === 'kam' ? "Ĩtika ĩngĩ thuutha" : "Try again later";
        alert(message);
      } else {
        localStorage['params'] = JSON.stringify({
          receiptNo: this.receiptNo
        })
        const routeData = this.$router.resolve({name: 'receipt'});
        window.open(routeData.href, '_blank');
      }
    },
    generateParkingBill(print) {
      //check if bill is already generated
      if (this.billGenerated.success) {
        if (print) {
          this.printBill()
        }
      } else {
        const data = new FormData();
        data.append("function", "generateParkingPayment");
        data.append("numberPlate", this.numberPlate);
        data.append("feeId", this.feesAndCharge.feeId);
        data.append("zone", this.zone);

        execute(data, parking)
            .then((res) => {
              if (res.data.success) {
                this.billGenerated = res.data.data.billGenerated;
                this.billDetails.billNo = this.billGenerated.billNo

                this.paymentData.accNo = this.billGenerated.billNo
                this.paymentData.payBillNo = this.billGenerated.payBillNo
                this.paymentData.amount = this.billGenerated.amount
                if (print) {
                  this.printBill()
                }
              } else {
                alert(res.data.message);
              }
            })
            .catch((e) => {
              alert(e.message);
            });
      }
    },
    checkPayment() {
      const data = new FormData();
      data.append("function", "checkPayment");
      data.append("accNo", this.paymentData.accNo);
      execute(data, paysol)
          .then((res) => {
            if (res.data.success) {
              this.Push = res.data.data.Push;

              if(this.Push.callback_returned ==="PAID"){
                clearInterval(this.timer);
                this.receipt = true;
                this.paymentData.success = false;
                this.transaction.transaction_code = this.Push.transaction_code
                this.receiptNo = this.Push.transaction_code
                this.incomeTypeDescription = this.feesAndCharge.feeDescription
                //Close the modal
                this.$refs.Close.click();
                this.$refs.showPaymentReceivedModal.click();

              }else if(this.Push.callback_returned ==="UNPAID"){
                clearInterval(this.timer);
              }
            }
          })
          .catch((e) => {
            alert(e.message);
          });
    },
    getIncomeTypes(incomeTypePrefix) {
      const data = new FormData();
      data.append("function", "getIncomeTypes");
      data.append("incomeTypePrefix", incomeTypePrefix);
      execute(data, biller)
          .then((res) => {
            if (res.data.success) {
              this.incomeTypes = res.data.data.incomeTypes;
            } else {
              //  alert(res.data.data.message);
            }
          })
          .catch((e) => {
            alert(e.message);
          });
    },
    getFeesAndCharges(incomeTypeId) {
      this.feesAndCharges.splice(0)
      const data = new FormData();
      data.append("function", "getFeesAndCharges");
      data.append("incomeTypeId", incomeTypeId);
      execute(data, biller)
          .then((res) => {
            if (res.data.success) {
              this.feesAndCharges = res.data.data.feesAndCharges
            } else {
              //  alert(res.data.data.message);
            }
          })
          .catch((e) => {
            alert(e.message);
          });
    },
    getIconPath(description) {
      const iconMap = {
        "Daily parking": "/img/icons/parking/offstreet-parking.svg",
        "Seasonal Parking": "/img/icons/parking/seasonal.svg",
        "Off-street parking": "/img/icons/parking/off-streetparking.svg",
        "Reserved parking": "/img/icons/parking/seasonal.svg",
        "Parking penalties": "/img/icons/parking/Penalties.svg"
      };
      return iconMap[description] || "/img/icons/parking/default.svg";
    },
    getCounty(){
      const data = new FormData();
      data.append("function", "getCounty");
      execute(data,authUrl)
          .then((res) =>{
            if (res.data.success) {
              this.county = res.data.data.county
            }else{
              // alert(res.data.message)
            }
          })
          .catch((e) => {
            //alert(e.message);
            this.message =e.message
          });
    },

    OTPVerificationPermit() {
      this.alert.info = true;
      this.alert.failed = false;
      this.alert.success = false;
      this.message = this.currentLanguage === 'sw' ? "Inathibitisha..." :
          this.currentLanguage === 'kam' ? "Nĩĩthibitisha..." : "Verifying..."
      const data = new FormData();
      data.append("function", "OTPVerificationPermit");
      data.append("enteredOTP", this.otpCode);
      data.append("id", this.permit.id);
      execute(data, trade)
          .then((res) => {
            if (res.data.success) {
              this.alert.info = false;
              this.alert.failed = false;
              this.alert.success = true;
              this.message = res.data.message;

              localStorage['params'] = JSON.stringify({
                businessID: this.businessID
              })
              const routeData = this.$router.resolve({name: 'trade'});
              window.open(routeData.href, '_blank');

            } else {
              this.alert.info = false;
              this.alert.failed = true;
              this.alert.success = false;
              this.message = res.data.message;
            }
          })
          .catch((e) => {
            //alert(e.message);
            this.message = e.message;
          });
    },
  },
  computed: {
    // Computed property for translated continue button
    continueButtonText() {
      if (this.continiueButtom === 'Please wait...' || this.continiueButtom === 'Tafadhali subiri...' || this.continiueButtom === 'Ĩkũlya vandũ vanini...') {
        return this.currentLanguage === 'sw' ? 'Tafadhali subiri...' :
            this.currentLanguage === 'kam' ? 'Ĩkũlya vandũ vanini...' : 'Please wait...';
      }
      return this.currentLanguage === 'sw' ? 'Endelea' :
          this.currentLanguage === 'kam' ? 'Thĩĩ na mbee' : 'Continue';
    }
  }
};
</script>

<style>
.language-selector {
  position: absolute;
  top: 20px;
  right: 20px;
  z-index: 1000;
  background: rgba(255, 255, 255, 0.9);
  padding: 5px 15px;
  border-radius: 25px;
  box-shadow: 0 2px 10px rgba(0,0,0,0.1);
}
.language-selector select {
  background: transparent;
  border: none;
  font-weight: 500;
  cursor: pointer;
  padding: 5px 10px;
}
.language-selector .mdi {
  color: #333;
  margin-right: 5px;
}
</style>